<template>
  <div id="questionsWrapper">
    <button class="button is-text has-text-link" @click="toggle">
      <span>Leervragen ({{ questionsCount }})</span>
      <span class="icon">
        <i class="fas" :class="isActive ? 'fa-chevron-down' : 'fa-chevron-left'"></i>
      </span>
    </button>

    <div v-show="isActive" class="box">
      <question
        v-for="(question, index) in myQuestions"
        :key="index"
        :index="index"
        :question="question"
        @edit="edit"
        @remove="remove"
      ></question>

      <create-button
        v-if="hasGrant(account, 4)"
        caption="Nieuwe leervraag"
        :pulledRight="false"
        @click="create">
      </create-button>
    </div>

    <edit-question
      v-if="hasGrant(account, 4)"
      :text="text"
      :question="question"
      :isActive="showEdit"
      @save="save"
      @close="close"
    ></edit-question>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import Question from '@/components/questions/Question'
import CreateButton from '@/components/modules/CreateButton'
import EditQuestion from '@/components/questions/EditQuestion'

export default {
  mixins: [
    authMixin
  ],
  props: [
    'text',
    'kvNr',
    'itemNr',
    'isOpened',
    'profileNr',
    'categoryNr',
    'activeSource'
  ],
  components: {
    Question,
    CreateButton,
    EditQuestion
  },
  data () {
    return {
      index: null,
      question: null,
      isActive: false,
      showEdit: false
    }
  },
  computed: {
    ...mapGetters({
      account: 'account/account',
      dossier: 'dossiers/dossier',
      questions: 'values/questions'
    }),
    questionsCount () {
      return this.myQuestions.length
    },
    myQuestions () {
      return this.questions.filter((question) => {
        return question.section === this.activeSource &&
          question.number === this.params.itemNr &&
          question.kv_number === this.params.kvNr &&
          question.profile_number === this.params.profileNr &&
          question.category_number === this.params.categoryNr
      })
    },
    params () {
      return {
        kvNr: (this.kvNr) ? parseInt(this.kvNr) : null,
        itemNr: (this.itemNr) ? parseInt(this.itemNr) : null,
        profileNr: (this.profileNr) ? parseInt(this.profileNr) : null,
        categoryNr: (this.categoryNr) ? parseInt(this.categoryNr) : null
      }
    }
  },
  created () {
    this.broadCastCount()
    this.isActive = this.isOpened
  },
  mounted () {
    this.broadCastCount()
  },
  watch: {
    isOpened () {
      this.isActive = this.isOpened
    }
  },
  methods: {
    toggle () {
      this.isActive = !this.isActive
    },
    toggleEdit (state) {
      this.showEdit = state
    },
    close () {
      this.toggleEdit(false)
      this.question = null
    },
    create () {
      this.question = {
        value: null,
        profile_number: this.profileNr
      }
      this.toggleEdit(true)
    },
    edit (payload) {
      this.question = payload
      this.toggleEdit(true)
    },
    save (payload) {
      if (!this.question.ids) {
        this.$store.dispatch('values/create', {
          values: [
            {
              value: payload.value,
              section: this.activeSource,
              number: this.params.itemNr,
              kv_number: this.params.kvNr,
              profile_number: this.params.profileNr,
              category_number: this.params.categoryNr
            }
          ],
          columnId: 34,
          mode: 'questions',
          bundles: (!this.inAdmin) ? payload.bundles : [null],
          dossier_number: (this.inAdmin) ? this.dossier.number : null
        })
      } else {
        this.$store.dispatch('values/save', {
          mode: 'questions',
          values: this.question.ids.map(valueId => {
            return {
              id: valueId,
              value: payload.value,
              index: this.getIndex(this.question)
            }
          })
        })
      }

      this.question = null
    },
    remove (payload) {
      this.$store.dispatch('values/remove', {
        mode: 'questions',
        values: payload.ids,
        index: this.getIndex(payload)
      })
    },
    getIndex (question) {
      return this.questions.findIndex((x) => {
        return x.value === question.value &&
          x.section === question.section &&
          x.number === question.number &&
          x.kv_number === question.kv_number &&
          x.profile_number === question.profile_number &&
          x.category_number === question.category_number
      })
    },
    broadCastCount () {
      this.$emit('count', {...this.params, ...{count: this.questionsCount}})
    }
  }
}
</script>

<style scoped>
  button.is-text {
    text-decoration: none;
    margin-bottom: 30px;
  }
</style>
